import updateEstimateField from '../../../Services/updateEstimateField';
import fetchEstimate from '../../../Services/fetchEstimate';

export default (field, value) => async (dispatch) => {

  await dispatch(updateEstimateField(field, parseFloat(value)));

  await dispatch(fetchEstimate());
  
}